export const Perlunasan = () => {
    return (
      <>
        Perlunasan
      </>
    )
  }